import { render, staticRenderFns } from "./ProblemWizard.vue?vue&type=template&id=aa6f1262&"
import script from "./ProblemWizard.vue?vue&type=script&lang=js&"
export * from "./ProblemWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports